import React, { HTMLAttributes } from "react";
import ICountry from "./models/ICountry";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            display: "flex",
            alignItems: "center",
            "& img": {
                height: "unset",
            },
        },
        label: {
            lineHeight: "inherit",
            marginLeft: theme.spacing(1),
        },
    })
);

interface IProps extends HTMLAttributes<HTMLDivElement> {
    country: ICountry;
}

export default function CountryOption(props: IProps) {
    const classes = useStyles();
    const { country, className = "", ...rest } = props;

    return (
        <div className={`${className} ${classes.root}`} {...rest}>
            <img src={country.flagImageLocation} alt={`${country.label.replace(" ", "")} Flag`} />
            <Typography variant="body1" className={classes.label}>
                {country.label}
            </Typography>
        </div>
    );
}
